var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: { hover: true },
        },
      ],
      staticClass: "btn btn-sm navbar-btn btn-secondary me-1 mb-1",
      attrs: { title: "Zeige Standbesuche" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.$emit("click")
        },
      },
    },
    [_c("i", { class: _vm.css })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }